export default __webpack_public_path__ + "static/media/remember.cf84c74e.png";